<template>
  <div>
    <nav class="bg-gray-800">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-16">
          <div class="flex items-center">
            <div class="flex-shrink-0 text-white mr-4">
              White Water Photography Platform Administration
            </div>
            <div class="flex items-center">
              <base-button-primary @click="logout" class="ml-4">
                Log Out
              </base-button-primary>
            </div>
          </div>
          <div class="flex items-center text-white">
            Welcome {{ user.name }}
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import BaseButtonPrimary from "../buttons/BaseButtonPrimary";
export default {
  name: "AdminNav",
  components: { BaseButtonPrimary },
  methods: {
    logout() {
      this.$store
        .dispatch("auth/logout")
        .then(() => {
          this.$router.push("/");
        })
        .catch();
    },
  },
  computed: {
    user: function () {
      return this.$store.getters["auth/getUser"];
    },
  },
};
</script>
